export default "__VITE_ASSET__CAuVy$Xs__ 100w";